import { DEFAULT_AMOUNT_SAMPLE } from "@app/pages/samples/utils/constants";
import { getCommonDefaultValues } from "../../utils/getCommonDefaultValues";

export const getDefaultValues = (defaultPreloadValues?: any) => {
  const { currentPreparationIndex } = defaultPreloadValues;

  const commonValues = getCommonDefaultValues(defaultPreloadValues);

  return {
    ...commonValues,
    //preparation
    analysis_amount_sample:
      currentPreparationIndex?.amount_sample || DEFAULT_AMOUNT_SAMPLE,
    scintillator_lot_number:
      currentPreparationIndex?.scintillator_lot_number || undefined,
    //counting
    //calculation
  };
};
